import { TAppState } from '../../types';
import { PreloadedState, configureStore } from '@reduxjs/toolkit';
import { IThunkContext } from '../../types/thunk';
import { rootReducer } from './rootReducer';

export function createReduxStore(thunkContext: IThunkContext) {
  const { config } = thunkContext;

  const preloadedState = config.getStrict<PreloadedState<TAppState>>('initialState');

  const reduxDevToolsName = `pay-package-frontend · ${config.get('mcsRunEnv')} · ${config.get('version.commit')}`;

  return configureStore({
    preloadedState,
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: { extraArgument: thunkContext },
      }),
    devTools: {
      name: reduxDevToolsName,
    },
  });
}
